var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitterinline = function SvgTwitterinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.375,
    stroke: "#fff",
    strokeOpacity: 0.15,
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M30 13.846c-.75.37-1.5.492-2.375.615.875-.492 1.5-1.23 1.75-2.215-.75.492-1.625.739-2.625.985a4.4 4.4 0 0 0-3-1.231c-2.125 0-4 1.846-4 4.061 0 .37 0 .616.125.862-3.375-.123-6.5-1.723-8.5-4.184-.375.615-.5 1.23-.5 2.092 0 1.354.75 2.584 1.875 3.323-.625 0-1.25-.246-1.875-.492 0 1.969 1.375 3.569 3.25 3.938-.375.123-.75.123-1.125.123-.25 0-.5 0-.75-.123.5 1.6 2 2.83 3.875 2.83C14.75 25.539 13 26.155 11 26.155h-1C11.875 27.262 14 28 16.25 28c7.5 0 11.625-6.154 11.625-11.446v-.492c.875-.616 1.625-1.354 2.125-2.216"
  })));
};
export default SvgTwitterinline;